import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/AntiBotGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UiModeProvider"] */ "/vercel/path0/frontend/components/UiModeProvider.tsx");
